import React, { useState } from 'react'
import { useParams } from 'react-router-dom';

export default function CreateNewEmployeeLeaveModal({ post, Employee, ModalId, setModalId, TabId, setTabId, showModalAndTab }) {
    const { server_id, admin_id } = useParams();
    const [FilterPayload, setFilterPayload] = useState({});

    const handleChange = e => {
        const { name, value } = e?.target;
        setFilterPayload({
            ...FilterPayload,
            [name]: value
        })
    }

    const handleChecked = e => {
        const { name, checked, value } = e?.target;
        if (checked) {
            setFilterPayload({
                ...FilterPayload,
                [name]: value
            })
        } else {
            setFilterPayload({
                ...FilterPayload,
                [name]: ''
            })
        }
    }

    const convertTo12HourFormat = (time24) => {
        // Split the input time into hours and minutes
        let [hours, minutes] = time24.split(':').map(Number);

        // Determine AM or PM suffix
        const period = hours >= 12 ? 'PM' : 'AM';

        // Convert 24-hour format to 12-hour format
        hours = hours % 12;
        hours = hours ? hours : 12;  // Handle case for 0 (midnight)

        // Format minutes as a two-digit string
        hours = hours < 10 ? `0${hours}` : hours;
        minutes = minutes < 10 ? `0${minutes}` : minutes;

        // Return the formatted time in 12-hour format
        return `${hours}:${minutes} ${period}`;
    }


    const convertTo24HourFormat = (time24) => {
        // Split the input time into hours and minutes
        let [hours, minutes, seconds] = time24.split(':').map(Number);

        // Determine AM or PM suffix
        const period = hours >= 12 ? 12 : 0;

        // Convert 24-hour format to 12-hour format
        // hours = hours % 12;
        hours = hours ? hours : 12;  // Handle case for 0 (midnight)

        hours = hours < 10 ? `0${hours}` : hours;

        // Format minutes as a two-digit string
        minutes = minutes < 10 ? `0${minutes}` : minutes;

        seconds = seconds < 10 ? `0${seconds}` : seconds;

        // Return the formatted time in 12-hour format
        return `${hours}:${minutes}:${seconds}`;
    }

    const saveLeave = async () => {
        const endpoint = "employees/employee_leave_days_for_schedule/create";
        const filter = {
            server_id: server_id,
            staff_id: FilterPayload?.staff_id,
            year: FilterPayload?.leave_start_date.split('-')[0],
            month: FilterPayload?.leave_start_date.split('-')[1],
            is_holiday: FilterPayload?.is_holiday,
            is_leave: FilterPayload?.is_leave,
            is_fullday_leave: FilterPayload?.is_fullday_leave,
            leave_type: FilterPayload?.leave_type,
            leave_start_date: FilterPayload?.leave_start_date,
            leave_start_time: convertTo12HourFormat(FilterPayload?.leave_start_time),
            leave_end_date: FilterPayload?.leave_end_date,
            leave_end_time: convertTo12HourFormat(FilterPayload?.leave_end_time),
        };
        try {
            const response = await post(endpoint, filter);
            if (response?.res) {
                alert("Leave Successfully Saved.");
                if ($("#manageForUserType").val() == 'USER') {
                    // await syncCareDays($("#service_user_filter").val(), $("#service_user_filter option:selected").text());
                    // await syncEvents($("#service_user_filter").val(), $("#service_user_filter option:selected").text(), $("#visit_category_for_service_user").val(), $("#visit_status_for_service_user").val());
                }


                if ($("#manageForUserType").val() == 'STAFF') {
                    // await syncWorkDays($("#employee_filter").val(), $("#employee_filter option:selected").text());
                    // await syncLeaves($("#employee_filter").val(), $("#employee_filter option:selected").text());
                    // await syncEmployeeEvents($("#employee_filter").val(), $("#employee_filter option:selected").text(), $("#schedule_type").val(), $("#visit_status_for_employee").val());
                }
            } else {
                alert(response?.msg)
            }
        } catch (error) {
            console.error('Error fetching data:', error);  // Handle any errors
        }
    }

    const updateLeave = async () => {
        const endpoint = "employees/employee_leave_days_for_schedule/update";
        const filter = {
            id: $("#id").val(),
            server_id: server_id,
            staff_id: FilterPayload?.staff_id,
            year: FilterPayload?.leave_start_date.split('-')[0],
            month: FilterPayload?.leave_start_date.split('-')[1],
            is_holiday: FilterPayload?.is_holiday,
            is_leave: FilterPayload?.is_leave,
            is_fullday_leave: FilterPayload?.is_fullday_leave,
            leave_type: FilterPayload?.leave_type,
            leave_start_date: FilterPayload?.leave_start_date,
            leave_start_time: convertTo12HourFormat(FilterPayload?.leave_start_time),
            leave_end_date: FilterPayload?.leave_end_date,
            leave_end_time: convertTo12HourFormat(FilterPayload?.leave_end_time),
        };
        try {
            const response = await post(endpoint, filter);
            if (response?.res) {
                alert("Leave Successfully Updated.");
                if ($("#manageForUserType").val() == 'USER') {
                    // await syncCareDays($("#service_user_filter").val(), $("#service_user_filter option:selected").text());
                    // await syncEvents($("#service_user_filter").val(), $("#service_user_filter option:selected").text(), $("#visit_category_for_service_user").val(), $("#visit_status_for_service_user").val());
                }


                if ($("#manageForUserType").val() == 'STAFF') {
                    // await syncWorkDays($("#employee_filter").val(), $("#employee_filter option:selected").text());
                    // await syncLeaves($("#employee_filter").val(), $("#employee_filter option:selected").text());
                    // await syncEmployeeEvents($("#employee_filter").val(), $("#employee_filter option:selected").text(), $("#schedule_type").val(), $("#visit_status_for_employee").val());
                }
            } else {
                alert(response?.msg)
            }
        } catch (error) {
            console.error('Error fetching data:', error);  // Handle any errors
        }
    }



    return (
        <>
            <div className={`modal fade ${ModalId == 'createNewEmployeeLeaveModal' ? 'show' : ''}`} id="createNewEmployeeLeaveModal" tabindex="-1" role="dialog"
                aria-labelledby="createNewEmployeeLeaveModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="createNewEmployeeLeaveModalLabel">Event</h5>
                            <button type="button" className="close" onClick={() => showModalAndTab('', '')}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <input type="hidden" id="year_Leave" />
                                <input type="hidden" id="month_Leave" />
                                <div className="form-group">
                                    <label>Staff</label>
                                    <select className="form-select" id="staff_Leave" onChange={handleChange}>
                                        <option value=""> - Select - </option>
                                        {
                                            Employee && Employee?.length > 0 ?
                                                Employee?.map((val, index) => (
                                                    <option value={`${val?.username}`}> {`${val?.full_name} (${val?.email})`} </option>
                                                ))
                                                : ''
                                        }
                                    </select>
                                </div>
                                <div className="row">
                                    <div className="container-fluid">
                                        <div className="form-group text-right">
                                            <div className="pretty p-switch p-fill">
                                                <input type="checkbox" id="is_holiday_Leave" onClick={handleChecked} />
                                                <div className="state p-success">
                                                    <label>Holiday ?</label>
                                                </div>
                                            </div>
                                            <div className="pretty p-switch p-fill">
                                                <input type="checkbox" id="is_leave_Leave" onClick={handleChecked} />
                                                <div className="state p-success">
                                                    <label>Leave ?</label>
                                                </div>
                                            </div>
                                            <div className="pretty p-switch p-fill">
                                                <input type="checkbox" id="is_fullday_leave_Leave" onClick={handleChecked} />
                                                <div className="state p-success">
                                                    <label>Full Day Leave ?</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Leave Type</label>
                                            <select className="form-control" id="leave_type_Leave" onChange={handleChange}>
                                                <option value=""> - Select - </option>
                                                <option value="CASUAL"> Casual Leave </option>
                                                <option value="MEDICAL"> Medical Leave </option>
                                                <option value="EMERGENCY"> Emergency </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Start Date</label>
                                            <input className="form-control" type="date" id="leave_start_date_Leave" onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Start Time</label>
                                            <input className="form-control" type="time" id="leave_start_time_Leave" onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>End Date</label>
                                            <input className="form-control" type="date" id="leave_end_date_Leave" onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>End Time</label>
                                            <input className="form-control" type="time" id="leave_end_time_Leave" onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => showModalAndTab('', '')}>Close</button>
                            <button type="button" className="btn btn-primary" id="saveEmployeeLeave" onClick={saveLeave}>Save</button>
                            <button type="button" className="btn btn-primary" id="updateEmployeeLeave" onClick={updateLeave}>Update</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
